import React from 'react';
import './TermsConditions.css'

const TermsConditions = ({
  termsAndConditions,
  onTermChange,
  onAddTerm,
  onRemoveTerm,
  isMobile
}) => {
  return (
    <div className="InvoiceForm__terms-container" style={{width: isMobile ? "100%" : "100%"}}>
      <h2 className="InvoiceForm__section-title">Terms & Conditions</h2>
      
      {termsAndConditions.map((term, index) => (
        <div key={index} className="InvoiceForm__term-row">
          <div className="InvoiceForm__term-input-container">
            <span className="InvoiceForm__term-number">{index + 1}.</span>
            <input
              type="text"
              placeholder={`Enter term ${index + 1}`}
              className="InvoiceForm__input InvoiceForm__term-input"
              value={term}
              onChange={(e) => onTermChange(index, e.target.value)}
            />
            
            {/* Show Add Term button only for first term */}
            {index === 0 && (
              <button
                type="button"
                onClick={onAddTerm}
                className="InvoiceForm__button InvoiceForm__button--add-term"
              >
                + Add Term
              </button>
            )}
            
            {/* Show Remove button for all terms except when there's only one */}
            {termsAndConditions.length > 1 && (
              <button
                type="button"
                onClick={() => onRemoveTerm(index)}
                className="InvoiceForm__button InvoiceForm__button--remove-term"
                title="Remove this term"
              >
                ×
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TermsConditions;
